module.exports = function() {
	return new Worker(__webpack_public_path__ + "0403f797272b0b5eccf5.comments.wrkr.js");
};